import React, { FC } from 'react';

import { Clients } from '@ariksa/notification';
import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';

export const LearnMoreAboutJiraProjectDefaultBoard: FC = () => {
  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="jira_project_default_board"
      headerTitle="Jira Project – Default Board"
      iconType={Clients.Jira}
      iconFilled={false}
      iconPadding={0}
      body={
        <Stack spacing={10}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Description</Text>
            <Text>
              Every Jira project can have multiple boards associated with it.
              These can be customer defined and use to track tickets that are
              assigned to sprints. However, it is possible that a board does not
              have any sprints created against it.
            </Text>
            <Text>
              Ariksa only displays boards that have associated sprints to ensure
              that are automatically or manually created can be tracked for
              progress as part of one or more sprints.
            </Text>
            <Text>
              When creating tickets, Ariksa tries to automatically assign
              tickets to the current sprint on the board.
            </Text>
          </Stack>
        </Stack>
      }
    />
  );
};
